/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type Image, ImageSchema } from './image'

/* TypeScript */
export type PressArticleContent = {
  technicalName?: Maybe<string>
  id: string
  text: string
  publicationDate: string
  link?: Maybe<ContentLink>
  image: Image
}

/* Schemas */
export const PressArticleContentSchema = z.object({
  technicalName: z.nullish(z.string()),
  id: z.string(),
  text: z.string(),
  publicationDate: z.string(),
  link: z.nullish(ContentLinkSchema),
  image: ImageSchema,
})

/* Schemas validation */
type TestPressArticleContent = ExpectTrue<
  Equal<PressArticleContent, z.infer<typeof PressArticleContentSchema>>
>
